import request from '@/utils/request';
export function fetchList(data) {
  return request({
    url: '/whg-park/api/staticFile/list',
    method: 'post',
    data: data
  });
}
export function fetchCreate(data) {
  return request({
    url: '/whg-park/api/staticFile/insert',
    method: 'post',
    data: data
  });
}
export function fetchUpdate(data) {
  return request({
    url: '/whg-park/api/staticFile/update',
    method: 'post',
    data: data
  });
}
export function fetchDetail(data) {
  return request({
    url: '/whg-park/api/staticFile/get',
    method: 'post',
    data: data
  });
}
export function fetchDelete(data) {
  return request({
    url: '/whg-park/api/staticFile/delete',
    method: 'post',
    data: data
  });
}